import React, { useEffect } from 'react';
import { Outlet } from "react-router-dom";
import Footer from 'components/layouts/Footer';
import Header from 'components/layouts/Header';
import ScrollToTop from 'components/ScrollToTop';
// import Notice from 'components/Notice';



const Root = () => {

    // Stop scroll wheel from changing the value of inputs with type number
    useEffect(() => {
        document.querySelectorAll('input[type=number]').forEach((input) => {
            input.addEventListener('wheel', function (event) {
                event.target.blur(); 
            });
        });

    }, []);
    return (
        <div className='main'>
            {/* <Notice /> */}
            {/* Scroll to top every time switch page */}
            <ScrollToTop />

            <Header />
            <Outlet /> {/* Contents... */}
            <Footer />
        </div>
    );
}

export default Root;
